/**
 * The texts of "Derive seriousness from the EMA IME list" (product owner, 25 Oct 2026).
 *
 * The first sentence of the confirmation is the product owner's own text.
 */
export const IME_SERIOUSNESS_TEXT = {
  title: "Derive seriousness from the EMA IME list",
  body: (listVersion: string): string =>
    `Seriousness criteria will be derived as per the EMA IME list version ${listVersion} for this event. `
    + "If the event's Preferred Term exists in the EMA IME list, the event's seriousness information will be updated.",
  onList: (preferredTerm: string): string =>
    `The Preferred Term ${preferredTerm} is on the list: only Medically Significant will be ticked, `
    + "and the Seriousness Notes will be the EMA IME sentence.",
  notOnList: (preferredTerm: string): string =>
    `The Preferred Term ${preferredTerm} is not on the list: every seriousness criterion will be unticked, `
    + "and the Seriousness Notes will be emptied.",
  noPreferredTerm: "The event has no Preferred Term: the seriousness information does not change now.",
  laterChange: "While this is on, a change of the Preferred Term applies the list again.",
  saveNote: "Nothing is stored until you click Save.",
  loading: "Reading the EMA IME list…",
  failed: "The EMA IME list could not be read. Cancel and try again.",
  accept: "Accept",
  cancel: "Cancel",
  /** Under the switch, after a change of the Preferred Term while it is on. */
  checking: (preferredTerm: string | undefined): string =>
    preferredTerm ? `Checking ${preferredTerm} against the EMA IME list…` : "Checking the new coding against the EMA IME list…",
  updatedOnList: (preferredTerm: string): string =>
    `Seriousness updated: ${preferredTerm} is on the EMA IME list, so only Medically Significant is ticked.`,
  updatedNotOnList: (preferredTerm: string): string =>
    `Seriousness updated: ${preferredTerm} is not on the EMA IME list, so every criterion is unticked and the notes are empty.`,
  keptNoPreferredTerm: "The event has no Preferred Term, so the seriousness stays as it is.",
  checkFailed: (preferredTerm: string | undefined): string =>
    `The EMA IME list could not be read for ${preferredTerm ?? "the new coding"}. Try again, or turn the switch off.`,
  followupOwned: (fields: string): string =>
    ` ${fields} kept: a follow-up proposal decides it.`,
  retry: "Try again",
  /** The Save button's reason while a check runs or failed. */
  saveWaits: "Wait for the EMA IME check of the Preferred Term, or turn the switch off.",
} as const;

/** The react-query key of the list's values for one preferred term or lower level term. */
export const IME_SERIOUSNESS_QUERY_KEY = "ema-ime-seriousness";
